var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"presse"},[_c('div',{staticClass:"topcontent"},[_c('HeaderBottom',{attrs:{"img":require('@/assets/img/bg7.jpg'),"message":'Presse'}}),_c('NavMenu')],1),_c('div',{staticClass:"centralcontent"},[_c('div',{staticClass:"liens"},[_vm._v(" Startseite | "),_c('router-link',{attrs:{"to":"/presse"}},[_vm._v("Presse")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }